module.exports = __webpack_public_path__ + "img/activity_detail.54260ba8.png";